'use strict';

function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

module.exports = endsWith;


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-dnd/dist-modules/utils/endsWith.js
 ** module id = 326
 ** module chunks = 0
 **/